<template>
    <span :id="id">{{label}}</span>
</template>

<script>
export default {
    inheritAttrs: false,
    name: 'title-dropdown-item',
    props: {
        id: {
            type: String,
            description: 'Id attr'
        },
        label: {
            type: String,
            description: 'Title label',
        },
    },
};
</script>

<style scoped lang="scss">
    span {
        display: block;
        font-weight: 700;
        color: #200033;
        text-transform: uppercase;
        margin-bottom: 14px;
        letter-spacing: 1px;
    }
</style>

